export class DeleteEquipment {
  message = "";
  validation: any = {
    messageValid: null,
  };
}
